import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=3c6c7580&scoped=true"
import script from "./origin.vue?vue&type=script&lang=js"
export * from "./origin.vue?vue&type=script&lang=js"
import style0 from "./origin.vue?vue&type=style&index=0&id=3c6c7580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c7580",
  null
  
)

export default component.exports